// removed by extract-text-webpack-plugin
module.exports = {"howToOrder":"qempo_HowToOrderModal_howToOrder-36aoo0A","carousel":"qempo_HowToOrderModal_carousel-B54-CS0","step":"qempo_HowToOrderModal_step-1587iMx","picture":"qempo_HowToOrderModal_picture-2zeG-Ue","backImage":"qempo_HowToOrderModal_backImage-1RXQshk","logoStore":"qempo_HowToOrderModal_logoStore-2nwXvNC","number":"qempo_HowToOrderModal_number-1eMUq5Y","dots":"qempo_HowToOrderModal_dots-34oajUl","formToOrder":"qempo_HowToOrderModal_formToOrder-37pNifd"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/stores/components/HowToOrderModal/HowToOrderModal.scss
// module id = 2011
// module chunks = 0